import { MINI_APP_ORIGIN } from "./website-config.ts";

export const MINI_APP_ASSET_ORIGIN = MINI_APP_ORIGIN;

// v1 uses generated/cards; v2 keeps immutable cards in generated/v2/<bundle>.
// Both are hosted by the Mini App, not copied into the lightweight website.
// Reject dot segments, URL escapes and non-image paths before rebasing URLs.
const GENERATED_ASSET_PATTERN = /^\/generated\/(?:v2\/[a-zA-Z0-9_-]+\/)?(?:cards|catalog-pages)\/(?:[a-zA-Z0-9_-][a-zA-Z0-9_.-]*\/)*[a-zA-Z0-9_-][a-zA-Z0-9_.-]*\.(?:webp|jpe?g|png)$/;

export function isGeneratedCatalogAsset(value: unknown): value is string {
  return typeof value === "string" && GENERATED_ASSET_PATTERN.test(value);
}

export function publicAssetUrl(
  value: string,
  website = true,
  assetOrigin = MINI_APP_ASSET_ORIGIN,
): string {
  if (!website || !isGeneratedCatalogAsset(value)) return value;
  return `${assetOrigin.replace(/\/$/, "")}${value}`;
}
